import {useEffect, useMemo} from 'react';

import isEmpty from 'lodash.isempty';
import {getChangeRequests} from 'src/modules/change-requests/services';
import {getChangeRequestInfo} from 'src/modules/event-create/services';
import {getUsersInfo} from 'src/modules/users-info/services';
import {getUsersByEmails} from 'src/openapi/apis/UserControllerApi';
import {useAppDispatch, useAppSelector} from 'src/store';
import {uniqueArrayString} from 'src/utils/uniqArray';

type Props = {
    emails?: string[],
    changeRequestId?: number | null,
};

export const UsersInfoController = ({emails, changeRequestId}: Props) => {
    const dispatch = useAppDispatch();
    const usersInfo = useAppSelector(getUsersInfo);
    const changeRequests = useAppSelector(getChangeRequests);
    const changeRequestInfo = useAppSelector(getChangeRequestInfo)?.[changeRequestId || 0];
    const usersEmailState = useMemo(() => Object.keys(usersInfo), [usersInfo]);

    useEffect(() => {
        const changeRequestInfoEmails = changeRequestInfo && changeRequestId ? [
            ...(changeRequestInfo.authorEmail ? [changeRequestInfo.authorEmail] : []),
            ...(changeRequestInfo.reviewerEmail ? [changeRequestInfo.reviewerEmail] : []),
            ...(changeRequestInfo.approverEmail ? [changeRequestInfo.approverEmail] : []),
        ] : [];

        const changeRequestsEmails = !isEmpty(changeRequests) && !changeRequestId ?
                changeRequests.flatMap(changeRequest => [
                    ...(changeRequest.authorEmail ? [changeRequest.authorEmail] : []),
                    ...(changeRequest.reviewerEmail ? [changeRequest.reviewerEmail] : []),
                    ...(changeRequest.approverEmail ? [changeRequest.approverEmail] : []),
                ]) : [];

        const uniqEmails = uniqueArrayString([
            ...changeRequestInfoEmails,
            ...changeRequestsEmails,
            ...(emails ? emails : []),
        ]);

        const missingEmails = uniqEmails.filter(email => !usersEmailState.includes(email));

        if (missingEmails.length) {
            dispatch(getUsersByEmails({emails: missingEmails}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changeRequestInfo, changeRequests, emails, dispatch]);

    return null;
};
